export const ticketConstants = {
  CREATE_TICKET_REQUEST: "CREATE_TICKET_REQUEST",
  CREATE_TICKET_SUCCESS: "CREATE_TICKET_SUCCESS",
  CREATE_TICKET_FAILURE: "CREATE_TICKET_FAILURE",
};
